import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, ReactReduxContext, Provider } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import { NewAffiliateWrap } from 'containers/Admin';
import { AgreementPreview, BillingForm, EmptyState, PageHeader } from 'components';
import { getContractData, getContractSigningToken } from 'redux/modules/contract';
import calculateContract from '../../../helpers/calculateContract';
import { editDialog, sendAffiliateClientAgreement } from 'redux/modules/newAffiliate';
import { showStripeError, initialSubscription } from 'redux/modules/billing';
import { getProducts } from 'redux/modules/products';
var PendingAffiliateClient = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme,
    sendingAgreement: state.newAffiliate.sendingAgreement,
    agreementSent: state.newAffiliate.agreementSent,
    contract: state.contract || null,
    config: state.config,
    form: state.form
  };
}, {
  getContractSigningToken: getContractSigningToken,
  getContractData: getContractData,
  getProducts: getProducts,
  editDialog: editDialog,
  sendAffiliateClientAgreement: sendAffiliateClientAgreement,
  showStripeError: showStripeError,
  initialSubscription: initialSubscription
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(PendingAffiliateClient, _Component);

  var _super = _createSuper(PendingAffiliateClient);

  function PendingAffiliateClient(props) {
    var _this2;

    _classCallCheck(this, PendingAffiliateClient);

    _this2 = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "handleBillingFormSubmit", function () {
      if (_this2.state.checkoutInProgress) {
        return console.error('Checkout is already in progress. Cannot initiate another checkout right now.');
      }

      _this2.setState({
        checkoutInProgress: true
      });

      var _this = _assertThisInitialized(_this2);

      var formData = _objectSpread(_objectSpread({}, _this2.props.form.billing.values), calculateContract(_this2.props.contract));

      Stripe.card.createToken({
        number: formData.cardNumber,
        exp_month: formData.expMonth,
        exp_year: formData.expYear,
        cvc: formData.cvc,
        name: formData.name,
        address_zip: formData.postcode
      }, function (status, response) {
        if (response.error) {
          _this.setState({
            checkoutInProgress: false
          });

          return _this2.props.showStripeError(response.error);
        }

        if (status === 200) {
          var contractAmounts = calculateContract(_this2.props.contract);
          formData.paymentSourceId = response.id;
          formData.monthlyAmountInCents = formData.totalDueToday;

          _this2.props.initialSubscription(formData, _this2.props.details.contract_uuid).then(function () {
            _this2.setState({
              showPaymentModal: false,
              checkoutInProgress: false
            });

            window.location.reload();
          })["catch"](function (err) {
            return console.error(err);
          });
        } else {
          _this.setState({
            checkoutInProgress: false
          });

          console.log(status, response);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "renderEmptyStateButtons", function () {
      var details = _this2.props.details;
      var buttons = [{
        label: 'View Agreement',
        onClick: function onClick() {
          _this2.setState({
            showAgreementModal: true
          });
        }
      }]; //
      // NOT SIGNED
      //

      if (!details.contract_signedAt) {
        buttons.push({
          label: _this2.state.loadingSigningToken ? /*#__PURE__*/React.createElement("i", {
            className: "fa fa-spinner fa-spin",
            style: {
              fontSize: 20
            }
          }) : 'Sign Now',
          onClick: function () {
            var _onClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var _yield$_this2$props$g, token;

              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _this2.setState({
                        loadingSigningToken: true
                      });

                      _context.next = 3;
                      return _this2.props.getContractSigningToken(details.contract_uuid);

                    case 3:
                      _yield$_this2$props$g = _context.sent;
                      token = _yield$_this2$props$g.data;

                      _this2.setState({
                        loadingSigningToken: false
                      });

                      if (token) {
                        window.location.href = "/agreements/".concat(details.contract_uuid, "?t=").concat(token, "&affiliatesign=true");
                      }

                    case 7:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            function onClick() {
              return _onClick.apply(this, arguments);
            }

            return onClick;
          }(),
          disabled: !!_this2.state.loadingSigningToken
        }, {
          label: _this2.props.sendingAgreement ? /*#__PURE__*/React.createElement("i", {
            className: "fa fa-spinner fa-spin",
            style: {
              fontSize: 20
            }
          }) : 'Email Agreement',
          onClick: function onClick() {
            _this2.props.sendAffiliateClientAgreement(details.contract_uuid);
          },
          disabled: _this2.props.sendingAgreement || _this2.props.agreementSent
        }, {
          label: 'Edit Client',
          onClick: function onClick() {
            _this2.props.editDialog(_this2.props.contract);

            _this2.setState({
              showNewAffiliateDialog: true
            });
          },
          disabled: _this2.props.agreementSent
        });
      } //
      // SIGNED
      //
      else {
          //
          // PAID BY SELF
          //
          if (details.contract_paymentDetailEntryType !== 1) {
            buttons.push({
              label: 'Enter Payment Details',
              onClick: function onClick() {
                _this2.setState({
                  showPaymentModal: true
                });
              },
              disabled: _this2.props.agreementSent && !details.contract_signedAt
            });
          } //
          // NEED TO ENTER PAYMENT DETAILS
          //
          else if (true) {
              console.log('thing');
            }
        }

      return buttons;
    });

    _this2.state = {
      showAgreementModal: false,
      showPaymentModal: false,
      showNewAffiliateDialog: false,
      checkoutInProgress: false
    };
    props.getContractData(props.details.contract_uuid);
    props.getProducts(props.theme.org); // So testing can get past this (`Stripe` will not be in scope in Jest because it is loaded from a linked JS file)

    global.Stripe || global.window && global.window.Stripe ? Stripe.setPublishableKey(props.config.stripePublicKey) : null;
    return _this2;
  }

  _createClass(PendingAffiliateClient, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var details = this.props.details;
      var text = details.contract_signedAt ? "".concat(details.organization_name, " has signed the agreement.") : this.props.agreementSent ? "Agreement has been sent to ".concat(details.organization_name, ".") : "".concat(details.organization_name, " has not signed the agreement.");
      var paymentStatusString = '';
      var warningPaymentStatusString = null;

      if (details.contract_signedAt) {
        if (this.props.contract.billingAccount && this.props.contract.billingAccount.id) {
          if (!this.props.contract.BillingAccountSubscription && this.props.contract.billingAccount.PaymentMethodId == 6) {
            warningPaymentStatusString = /*#__PURE__*/React.createElement("span", null, "Customer has been created and a billing account has been created for them,", /*#__PURE__*/React.createElement("br", null), "but a subscription was not created properly.", /*#__PURE__*/React.createElement("br", null), "Charge may need to be retried.");
          } else if (this.props.contract.billingAccount.PaymentMethodId === 6) {
            paymentStatusString = 'Customer has been charged via Stripe and a billing account has been created for them.';
          } else if (this.props.contract.billingAccount.PaymentMethodId === 7) {
            paymentStatusString = 'Customer is billed through Henry Schein. It is the responsibility of the Sales Rep to ensure this customer is being charged.';
          } else if (this.props.contract.billingAccount.PaymentMethodId === 9) {
            paymentStatusString = 'Customer is billed through some other external system. Please make sure this customer is paying somehow.';
          } else {
            paymentStatusString = 'Customer has a billing account in some unexpected way. Please make sure this customer is paying somehow.';
          }
        } else {
          paymentStatusString = 'Customer has not set up payment yet.';
        }
      } else {
        paymentStatusString = 'Customer has not signed the agreement yet.';
      }

      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column'
        },
        id: "PendingAffiliateClient"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          padding: '0 36px',
          minHeight: 60
        }
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: details.organization_name,
        style: {
          marginBottom: 16
        }
      })), /*#__PURE__*/React.createElement(EmptyState, {
        buttons: this.renderEmptyStateButtons(),
        multipleButtons: true,
        text: text,
        iconName: details.contract_signedAt ? 'icon ion-ios-checkmark-outline' : 'fa fa-send',
        iconStyle: details.contract_signedAt ? {
          color: 'green',
          fontSize: 110,
          margin: '8px 0'
        } : null,
        iconSize: "95px",
        style: {
          marginTop: 24,
          width: 480
        }
      }), this.props.contract && /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(Dialog, {
          autoScrollBodyContent: true,
          open: _this3.state.showAgreementModal,
          onRequestClose: function onRequestClose() {
            _this3.setState({
              showAgreementModal: false
            });
          }
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement("div", null, warningPaymentStatusString && /*#__PURE__*/React.createElement("div", {
          style: {
            padding: '16px 0',
            textAlign: 'center',
            color: 'red'
          }
        }, warningPaymentStatusString), /*#__PURE__*/React.createElement("div", {
          style: {
            padding: '16px 0',
            textAlign: 'center',
            color: '#000000'
          }
        }, paymentStatusString), /*#__PURE__*/React.createElement(AgreementPreview, {
          style: {
            boxShadow: 'none',
            margin: 0,
            padding: 0
          },
          isAffiliateClientContract: true,
          contract: _this3.props.contract
        }))));
      }), /*#__PURE__*/React.createElement(ReactReduxContext.Consumer, null, function (ctx) {
        return /*#__PURE__*/React.createElement(Dialog, {
          title: "Credit card for ".concat(details.organization_name),
          autoScrollBodyContent: true,
          open: _this3.state.showPaymentModal,
          onRequestClose: function onRequestClose() {
            _this3.setState({
              showPaymentModal: false
            });
          }
        }, /*#__PURE__*/React.createElement(Provider, {
          store: ctx.store
        }, /*#__PURE__*/React.createElement(BillingForm, {
          onSubmit: _this3.handleBillingFormSubmit,
          showTotal: false,
          checkoutInProgress: _this3.state.checkoutInProgress
        })));
      }), /*#__PURE__*/React.createElement(NewAffiliateWrap, {
        edit: true,
        contractInfo: this.props.contract,
        open: this.state.showNewAffiliateDialog,
        onClose: function onClose() {
          _this3.setState({
            showNewAffiliateDialog: false
          });
        }
      }));
    }
  }]);

  return PendingAffiliateClient;
}(Component)) || _class);
export { PendingAffiliateClient as default };